<ng-container *ngIf="data$ | async as data">
  <div class="container">
    <app-custom-image-info [item]="data.imageInfoComponent1"></app-custom-image-info>
    <app-custom-image-info [item]="data.imageInfoComponent2"></app-custom-image-info>
  </div>
</ng-container>
